module.exports = __webpack_public_path__ + "img/alert-envio.ca664d6b.svg";